import { render, staticRenderFns } from "./sheba.vue?vue&type=template&id=3c98f967&scoped=true&"
import script from "./sheba.vue?vue&type=script&lang=js&"
export * from "./sheba.vue?vue&type=script&lang=js&"
import style0 from "./sheba.vue?vue&type=style&index=0&id=3c98f967&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c98f967",
  null
  
)

export default component.exports